var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningUnenrollIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/danger"
  }, /*#__PURE__*/React.createElement("g", {
    id: "danger"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8 6.5V9.83333",
    stroke: "#FF852D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M8.00028 14.7735H3.96028C1.64695 14.7735 0.680281 13.1202 1.80028 11.1002L3.88028 7.35352L5.84028 3.83352C7.02695 1.69352 8.97361 1.69352 10.1603 3.83352L12.1203 7.36018L14.2003 11.1068C15.3203 13.1268 14.3469 14.7802 12.0403 14.7802H8.00028V14.7735Z",
    stroke: "#FF852D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M7.99609 11.834H8.00208",
    stroke: "#FF852D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningUnenrollIcon);
export default __webpack_public_path__ + "static/media/warning-unenroll-icon.178e0ac2a5a91208bbcc1aeef2005c99.svg";
export { ForwardRef as ReactComponent };